import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../contexts/AuthContext';

// Palette of distinct colors for user avatars
const COLORS = [
  'bg-blue-500', 'bg-emerald-500', 'bg-violet-500', 'bg-amber-500',
  'bg-rose-500',  'bg-cyan-500',   'bg-fuchsia-500','bg-orange-500',
  'bg-teal-500',  'bg-indigo-500',
];

function colorFor(id = '') {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = id.charCodeAt(i) + ((hash << 5) - hash);
  return COLORS[Math.abs(hash) % COLORS.length];
}

let _cache = null;
let _promise = null;

export function useUsersMap() {
  const [map, setMap] = useState(_cache || {});

  useEffect(() => {
    if (_cache) { setMap(_cache); return; }
    if (!_promise) {
      _promise = axios.get(`${API}/users?limit=200`)
        .then(r => {
          const m = {};
          (r.data || []).forEach(u => {
            const uid = u.id || u._id;
            m[uid] = { ...u, color: colorFor(uid) };
          });
          _cache = m;
          return m;
        })
        .catch(() => ({}));
    }
    _promise.then(m => setMap(m));
  }, []);

  return map;
}

/** Invalidate cache (call after user create/update) */
export function invalidateUsersCache() {
  _cache = null;
  _promise = null;
}
